import { render, staticRenderFns } from "./GeneralConsentReport.vue?vue&type=template&id=6ec38c86&scoped=true"
import script from "./GeneralConsentReport.vue?vue&type=script&lang=js"
export * from "./GeneralConsentReport.vue?vue&type=script&lang=js"
import style0 from "./GeneralConsentReport.vue?vue&type=style&index=0&id=6ec38c86&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec38c86",
  null
  
)

export default component.exports